import React from 'react';

const adminStatusContext = React.createContext(null);

export default adminStatusContext;